module.exports = __webpack_public_path__ + "img/adult_thumbnail.4c608751.png";